import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useLangContext } from '../context/lang.context'

const Seo = ({
  title,
  desc,
  keywords,
  image,
  imageUrl,
  url = '',
  noIndex,
  isArticle,
  isContact,
  isMainPage,
  lang: langProp,
  createdAt,
  updatedAt,
  children,
}) => {
  const { lang: langContext } = useLangContext()
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            siteUrl
          }
        }
      }
    `
  )

  const home = 'https://omida.pl/'
  const author = site.siteMetadata.title
  const img = imageUrl ? imageUrl : image ? home + image : home + 'ogimage.jpg'
  const lang = langProp || langContext || 'pl'

  const schemaOrgWebSite = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: site.siteMetadata.title,
    url: site.siteMetadata.siteUrl,
  }

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      titleTemplate={`%s | ${author}`}>
      <meta name='description' content={desc} />
      <meta property='og:description' content={desc} />

      {isMainPage && (
        <script type='application/ld+json'>
          {JSON.stringify(schemaOrgWebSite)}
        </script>
      )}

      <meta property='og:site_name' content={author} />
      <meta property='og:title' content={title} />
      <meta property='og:type' content={isArticle ? `article` : `website`} />
      <meta property='og:image' content={img} />
      <meta name='theme-color' content='#b6c905' />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:creator' content={author} />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={desc} />
      <meta name='twitter:image' content={img} />
      <meta
        property='og:url'
        content={url ? home + url + '/' : 'https://omida.pl'}
      />
      <link
        rel='canonical'
        href={url ? home + url + '/' : 'https://omida.pl'}
      />
      <link rel='dns-prefetch' href='//fonts.googleapis.com' />
      <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin />
      <link
        rel='preload'
        href='/fonts/fonts.css'
        as='font'
        crossorigin='anonymous'
      />
      {keywords && keywords.length > 0 && (
        <meta name='keywords' content={keywords} />
      )}
      {noIndex && <meta name='robots' content={'noindex, nofollow'} />}
      {noIndex && <meta name='googlebot' content={'noindex'} />}
      {noIndex && <meta name='googlebot-news' content={'nosnippet'} />}
      {noIndex && <meta name='AdsBot-Google' content={'noindex'} />}

      {isArticle && (
        <script type='application/ld+json'>
          {schemaArticle({
            title,
            img,
            url,
            datePublished: createdAt,
            dateModified: updatedAt,
          })}
        </script>
      )}
      {isContact && (
        <script type='application/ld+json'>
          {schemaContact({ title, desc, img, url })}
        </script>
      )}

      {children}
    </Helmet>
  )
}

const schemaArticle = ({ title, img, datePublished, date, url }) =>
  `{
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "${url}",
      "url": "${url}"
    },
    "headline": "${title}",
    "image": [
      "${img}"
    ],
    "datePublished": "${datePublished}",
    "dateModified": "${date}",
    "author": {
      "@type": "Person",
      "name": "Omida VLS",
      "url": "https://omida.pl/blog/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Omida VLS",
      "logo": {
        "@type": "ImageObject",
        "url": "https://omida.pl/icons/icon-512x512.png"
      }
    }
  }`

const schemaContact = ({ title, desc, img, url }) =>
  `{
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "${url}",
  "url": "${url}",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "${url}",
    "url": "${url}"
  },
  "name": "Omida VLS",
  "headline": "${title}",
  "title": "${title}",
  "description": "${desc}",
  "image": "${img}",
  "logo": "https://omida.pl/icons/icon-512x512.png",
  "address": "Aleja Grunwaldzka 472C, 80-309 Gdańsk, Polska",
  "geo": {
    "latitude": 54.403286203087426,
    "longitude": 18.569809564273466
  },
  "telephone": "+48 58 741 88 14"
}`

export default Seo
